import React from 'react';
import classnames from 'classnames';
import {getTextChunks, mapTextChunks} from '../../../utils/texts';
import styles from './styles.module.scss';

const getPlansInProgressSection = (context) => {
  const {plansInProgress} = context.data.pdfData;
  const chunks = Boolean(plansInProgress)
    ? getTextChunks(plansInProgress)
    : [];

  return chunks.length > 0 ? [
      <div className={classnames(styles.textRegular, styles.bold, styles.innerPadding)} key={0}>
        תכניות מופקדות:
      </div>,
      ...chunks
        .map(mapTextChunks)
        .map((item, index, array) => (
          <div className={classnames(
            styles.innerPadding,
            styles.textRegular,
            {[styles.lastSectionLine]: index === array.length - 1}
          )}>
            {item}
          </div>
        ))
    ]
    : [];
};

export default getPlansInProgressSection;
